<div class="wrapper-no-chats-yet">
    <img src="../../../../../assets/images/illustration/tmpty-chat.svg" alt="">
    <span>{{'CHAT.no_chats_yet' | translate}}</span>
</div>